let idElement = '#' + document.querySelector('.sibling__link--current').closest('[data-tab-content]').getAttribute('id');
document.querySelector('.sibling__link--current').closest('[data-tab-content]').classList.add('active');
let tabsElements = document.querySelectorAll('.product__block .tabs li');

if (tabsElements.length > 0) {
    tabsElements.forEach(function (element) {
        if (idElement && idElement == element.getAttribute('data-tab-target')) {
            element.classList.add('active');
        }
    });
}

document.querySelectorAll('.sibling__link').forEach(function (element) {

    element.addEventListener("click", function () {
        let spanColor = element.parentElement.parentElement.querySelector('span').textContent;
        let imageColor = element.querySelector('img').srcset;
        let idTab = element.closest('[data-tab-content]').getAttribute('id');
        localStorage.setItem("spanColor", spanColor);
        localStorage.setItem("idTab", idTab);
        localStorage.setItem("imageColor", imageColor);
        element.parentElement.parentElement.classList.add("select-popout__item--hide");
    });


    if (!!localStorage.spanColor) {
        const el = document.querySelector(`#${localStorage.getItem('idTab')} li span`)
        if (el) el.textContent = localStorage.spanColor;
    }

    if (!!localStorage.imageColor) {
        const el = document.querySelector(`#${localStorage.getItem('idTab')} li img`)
        if (el) el.srcset = localStorage.imageColor;
    }

});


document.querySelectorAll('[data-tab-target]').forEach((el) => {
    let idColor = el.getAttribute('data-tab-target');

    document.querySelectorAll('[data-tab-content]').forEach((element) => {

        if (idColor == '#' + element.getAttribute('id')) {
            let hrefNew = element.querySelector('li:first-child a')?.getAttribute("href");
            el.querySelector('a')?.setAttribute("href", hrefNew ? hrefNew : '#');
        }
    });
});


const slider = document.querySelector(".product__page ul.tabs");
let isDown = false;
let startX;
let scrollLeft;

if (slider) {
    slider.addEventListener("mousedown", e => {
        isDown = true;
        slider.classList.add("active");
        startX = e.pageX - slider.offsetLeft;
        scrollLeft = slider.scrollLeft;
    });
    slider.addEventListener("mouseleave", () => {
        isDown = false;
        slider.classList.remove("active");
    });
    slider.addEventListener("mouseup", () => {
        isDown = false;
        slider.classList.remove("active");
    });
    slider.addEventListener("mousemove", e => {
        if (!isDown) return;
        e.preventDefault();
        const x = e.pageX - slider.offsetLeft;
        const walk = x - startX;
        slider.scrollLeft = scrollLeft - walk;
    });
}